<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>Dedicated to Jim, Joanne, Martha, and Pete</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?84794a7c